import { vars } from "@frontend/styles";

export const TREE_TAG_NAME = "tree" as const;

export const TREE_ITEM_TAG_NAME = "tree-item" as const;

// Shared layout geometry — kept in one place because TreeItem's row/chevron
// placement and TreeGuides' elbow/line positions must line up exactly.
export const TREE_INDENT = "1.5rem";
export const TREE_ROW_HEIGHT = vars.dimension.sm;
export const TREE_ELBOW_HEIGHT = `calc(${TREE_ROW_HEIGHT} / 2)`; // where the elbow curves into the row
export const TREE_ELBOW_RADIUS = "6px";
export const TREE_ROW_PADDING_X = vars.spacing.xs;
export const TREE_CHEVRON_SLOT_WIDTH = "1rem";
// Horizontal position of a row's chevron center, from its item's outer edge
// — row padding plus half the chevron slot. Every row shares this geometry,
// so a child's guide line must sit here to land under its parent's chevron.
export const TREE_CHEVRON_CENTER = `calc(${TREE_ROW_PADDING_X} + ${TREE_CHEVRON_SLOT_WIDTH} / 2)`;
